import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.users || initialState;

const makeSelectUsersList = () =>
  createSelector(select, subState => subState.usersList);
const makeSelectCustomersList = () =>
  createSelector(select, subState => subState.customersList);
const makeSelectOrgansList = () =>
  createSelector(select, subState => subState.organsList);

// const makeSelectUser = () => createSelector(select, subState => subState.user);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectOrgansList,
  makeSelectCustomersList,
  makeSelectUsersList,
  // makeSelectUser,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
};
